// Call Contributions
import { apiAuth, apiPublic } from '../../utils/hooks';

const getOneContribution = (idContribution) => {
    return apiAuth()
        .get(`/carbon/contributions/${idContribution}`)
        .then((data) => data.data)
        .catch((error) => {
            throw error;
        });
};

const getAllContributions = (params) => {
    return apiAuth()
        .get('/carbon/contributions', { params: params })
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const createOneContribution = (mode) => {
    return apiAuth(mode)
        .post('/carbon/contributions')
        .then((data) => data.data);
};

const deleteOneContribution = (idContribution) => {
    return apiAuth()
        .delete(`/carbon/contributions/${idContribution}`)
        .then((data) => data);
};

const getRemainder = (test, mode) => {
    return apiAuth(mode)
        .get('/carbon/statistics/remainder', { params: { test: test } })
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getProjectById = (idProject) => {
    return apiAuth()
        .get(`/carbon/projects/${idProject}`, {})
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const getCarbonContributed = (mode, params) => {
    return apiAuth(mode)
        .get(`/carbon/statistics/contribution`, { params: params })
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

const sendPostMessage = (params) => {
    return apiPublic()
        .post(
            `/webhook/payment?orderId=${params.orderId}&pid=${params.pid}&result=${params.result}`,
        )
        .then((data) => data)
        .catch((error) => {
            throw error;
        });
};

export {
    getOneContribution,
    getAllContributions,
    createOneContribution,
    getRemainder,
    getProjectById,
    getCarbonContributed,
    sendPostMessage,
    deleteOneContribution,
};
